import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=0d256d85&scoped=true"
import script from "./DateFormat.vue?vue&type=script&lang=js"
export * from "./DateFormat.vue?vue&type=script&lang=js"
import style0 from "./DateFormat.vue?vue&type=style&index=0&id=0d256d85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d256d85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d256d85')) {
      api.createRecord('0d256d85', component.options)
    } else {
      api.reload('0d256d85', component.options)
    }
    module.hot.accept("./DateFormat.vue?vue&type=template&id=0d256d85&scoped=true", function () {
      api.rerender('0d256d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/DateFormat.vue"
export default component.exports